import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Spin, Button, Typography, message, Descriptions } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import GenericAddRemoveMultipleRecords from "./GenericAddRemoveMultipleRecordsUI";

const { Title, Paragraph } = Typography;

const AppDetail = ({ record, onBack }) => {
//   const { id } = useParams();
  const navigate = useNavigate();

  const [app, setApp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState([]); // all Tabs
  const [selectedTabsIds, setSelectedTabsIds] = useState([]); // assigned to app
  const [savingTabs, setSavingTabs] = useState(false);
  const [editingTabs, setEditingTabs] = useState(false); // NEW: edit mode flag

  useEffect(() => {
    console.log('Fetching details for app ID:', record);
    // fetchAppDetail();
    setSelectedTabsIds(record?.tabs || []);
    setApp(record);
    fetchTabs();
  }, [record]);

//   const fetchAppDetail = async () => {
//     try {
//       setLoading(true);
//       const apiService = new ApiService(
//         `${BASE_URL}/mt_apps/${record?._id}`,
//         { "Content-Type": "application/json" },
//         "GET"
//       );
//       const res = await apiService.makeCall();
//       setApp(res);
//       setSelectedTabsIds(res.tabs || []);
//     } catch (error) {
//       console.error("Error fetching app detail:", error);
//       message.error("Failed to fetch app detail");
//     } finally {
//       setLoading(false);
//     }
//   };

  const fetchTabs = async () => {
    try {
      const tabService = new ApiService(
        `${BASE_URL}/mt_tabs`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const tabResponse = await tabService.makeCall();
      setTabs(Array.isArray(tabResponse) ? tabResponse : []);
    } catch (error) {
      console.error("Error fetching tabs:", error);
      message.error("Failed to fetch tabs");
    }
  };

  const handleUpdateSelectedTabs = (newSelectedKeys) => {
    setSelectedTabsIds(newSelectedKeys);
  };

  const handleSaveTabs = async () => {
    try {
      setSavingTabs(true);
      const apiService = new ApiService(
        `${BASE_URL}/mt_apps/${app._id}`,
        { "Content-Type": "application/json" },
        "PUT",
        { mt_app: { ...app, tabs: selectedTabsIds } }
      );
      await apiService.makeCall();
      message.success("Tabs updated successfully");
  
      // Update app.Tabs to reflect saved data
      setApp((prevApp) => ({ ...prevApp, tabs: selectedTabsIds }));
  
      setEditingTabs(false); // exit edit mode after save
    } catch (error) {
      console.error("Error saving Tabs:", error);
      message.error("Failed to save Tabs");
    } finally {
      setSavingTabs(false);
    }
  };
  

  if (loading) return <Spin size="large" />;

  return (
    <div style={{ padding: 16 }}>
      <Card style={{ marginBottom: 24 }}>
      <Button onClick={() => onBack && onBack()} style={{ marginBottom: 16 }}>
            Back
        </Button>
        {app ? (
          <>
            <Title level={3}>{app.name}</Title>
            <Descriptions bordered column={1} size="small">
              <Descriptions.Item label="Label">{app.label}</Descriptions.Item>
              <Descriptions.Item label="Type">{app.type}</Descriptions.Item>
              <Descriptions.Item label="Active">{app.active ? "Yes" : "No"}</Descriptions.Item>
              <Descriptions.Item label="Default">{app.default ? "Yes" : "No"}</Descriptions.Item>
              <Descriptions.Item label="Description">{app.description || "N/A"}</Descriptions.Item>
            </Descriptions>
          </>
        ) : (
          <Paragraph>No details found.</Paragraph>
        )}
      </Card>

      {/* Tabs Section */}
        <Card
        title="Assign Tabs"
        extra={
            editingTabs ? (
            <>
                <Button
                type="primary"
                onClick={handleSaveTabs}
                loading={savingTabs}
                style={{ marginRight: 8 }}
                >
                Save
                </Button>
                <Button
                onClick={() => {
                    setEditingTabs(false);
                    setSelectedTabsIds(app.tabs || []); // revert changes
                }}
                >
                Cancel
                </Button>
            </>
            ) : (
            <Button onClick={() => setEditingTabs(true)}>Edit Tabs</Button>
            )
        }
        >
        {editingTabs ? (
            <GenericAddRemoveMultipleRecords
            titleLeft="Available Tabs"
            titleRight="Assigned Tabs"
            dataSource={tabs}
            selectedKeys={selectedTabsIds}
            onUpdateSelectedKeys={handleUpdateSelectedTabs}
            columnsLeft={[{ title: "Name", dataIndex: "name" }]}
            columnsRight={[{ title: "Name", dataIndex: "name" }]}
            searchFields={["name"]}
            />
        ) : (
            <ul>
            {selectedTabsIds.length > 0
                ? tabs
                    .filter((tab) => selectedTabsIds.includes(tab._id))
                    .map((tab) => <li key={tab._id}>{tab.name}</li>)
                : "No Tabs assigned."}
            </ul>
        )}
        </Card>
    </div>
  );
};

export default AppDetail;
